// Function originally from selector.html
    const imageMap = {
        schwarz: { kein: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/Zwischenueberschrift_hinzufuegen_1600_x_1600_px_2.jpg?v=1750781576', schwarz: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/black_black.png?v=1753726079', rosa: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/black_rosa.png?v=1753726080', lila: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/black_lila.png?v=1753726080', rot: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/black_rot.png?v=1753726080', gruen: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/black_green.png?v=1753726080', weiss: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/black_white.png?v=1753726080' },
        weiss: { kein: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/white-0001.png?v=1742920656', schwarz: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/white_black.png?v=1753726080', rosa: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/white_rosa.png?v=1753726080', lila: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/white_lila.png?v=1753726080', rot: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/white_rot.png?v=1753726080', gruen: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/white_green.png?v=1753726080', weiss: 'https://cdn.shopify.com/s/files/1/0549/4469/4522/files/white_weiss.png?v=1753726079' }
    };

    function updateCardUI(card) {
        const colorInput = card.querySelector('input[name^="color"]:checked');
        const bandInput = card.querySelector('input[name^="band"]:checked');
        const img = card.querySelector('.luada-ps-image img');
        if (img && colorInput && bandInput) {
            const color = colorInput.value;
            const band = bandInput.value;
            if (imageMap[color] && imageMap[color][band]) {
                img.src = imageMap[color][band];
            }
        }
        
        const subInput = card.querySelector('input[name^="sub"]:checked');
        if (subInput) {
            card.querySelector('.luada-ps-current-price').textContent = subInput.dataset.price;
            card.querySelector('.luada-ps-subscription-price').textContent = subInput.dataset.subscriptionText;
            card.querySelector('.luada-ps-old-price').textContent = `statt ${subInput.dataset.oldPrice}`;
            card.querySelector('.luada-ps-footer-savings').textContent = subInput.dataset.savingsText;
        } else if (card.dataset.productId === '3') { // Handle product 3's unique pricing
            card.querySelector('.luada-ps-current-price').textContent = "279,95 €";
            const subscriptionPrice = card.querySelector('.luada-ps-subscription-price');
            if (subscriptionPrice) subscriptionPrice.style.display = 'none'; // Hide subscription part
            const oldPrice = card.querySelector('.luada-ps-old-price');
            if (oldPrice) oldPrice.style.display = 'none'; // Hide old price
            const savings = card.querySelector('.luada-ps-footer-savings');
            if (savings) savings.textContent = "einmalige Zahlung"; // Update savings text
        }

        if(colorInput) card.querySelector('.luada-ps-option-label-selected-value').textContent = colorInput.dataset.name;
        const bandLabelValue = card.querySelectorAll('.luada-ps-option-label-selected-value')[1];
        if(bandInput && bandLabelValue) bandLabelValue.textContent = bandInput.dataset.name;
    }
    
    // Helper functions for external navigation to selector
    window.navigateToLuadaSelector = function(productId, options = {}) {
        const selector = document.querySelector('.luada-ps-selector');
        if (!selector) return;

        const targetCard = selector.querySelector(`[data-product-id="${productId}"]`);
        if (!targetCard) return;

        // Activate the target card
        const allCards = selector.querySelectorAll('.luada-ps-card');
        allCards.forEach(c => c.classList.remove('active'));
        targetCard.classList.add('active');

        // Set subscription plan if specified
        if (options.plan) {
            const planInput = targetCard.querySelector(`input[name="sub-${productId}"][value="${options.plan}"]`);
            if (planInput) {
                planInput.checked = true;
            }
        }

        // Set color if specified
        if (options.color) {
            const colorInput = targetCard.querySelector(`input[name="color-${productId}"][value="${options.color}"]`);
            if (colorInput) {
                colorInput.checked = true;
            }
        }

        // Set band if specified
        if (options.band) {
            const bandInput = targetCard.querySelector(`input[name="band-${productId}"][value="${options.band}"]`);
            if (bandInput) {
                bandInput.checked = true;
            }
        }

        // Update the UI
        updateCardUI(targetCard);

        // Scroll to selector with smooth animation
        selector.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
        });

        // Optional: Add a brief highlight effect
        targetCard.style.transform = 'scale(1.02)';
        targetCard.style.transition = 'transform 0.3s ease';
        setTimeout(() => {
            targetCard.style.transform = '';
        }, 500);
    };

    // Quick navigation functions for common scenarios
    window.selectSorglosPaket = (plan = 'monthly', color = 'schwarz', band = 'schwarz') => {
        navigateToLuadaSelector('1', { plan, color, band });
    };

    window.selectNotrufzentrale = (plan = 'monthly', color = 'schwarz', band = 'schwarz') => {
        navigateToLuadaSelector('2', { plan, color, band });
    };

    window.selectEinzelgeraet = (color = 'schwarz', band = 'schwarz') => {
        navigateToLuadaSelector('3', { color, band });
    };